'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPreview = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _baseButtons = require('@bibliocommons/base-buttons');

var _privacyToggle = require('../../privacy-toggle');

var _privacyToggle2 = _interopRequireDefault(_privacyToggle);

require('../styles/VideoPreview.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoPreview = exports.VideoPreview = function (_BcReactComponent) {
  _inherits(VideoPreview, _BcReactComponent);

  function VideoPreview(props) {
    _classCallCheck(this, VideoPreview);

    var _this = _possibleConstructorReturn(this, (VideoPreview.__proto__ || Object.getPrototypeOf(VideoPreview)).call(this, props));

    _this.bindAll('renderTitle', 'renderDescription', 'renderActions');
    return _this;
  }

  _createClass(VideoPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* for testing purposes */}
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      return _react2.default.createElement(
        'h3',
        null,
        this.props.videoTitle
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (this.props.description) {
        return _react2.default.createElement(
          'p',
          null,
          this.props.description
        );
      }
      return null;
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      return _react2.default.createElement(
        'div',
        { className: 'ugc-actions' },
        _react2.default.createElement(
          _baseButtons.TextButton,
          { handleClick: this.props.handleShowForm },
          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-edit' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_button' })
        ),
        _react2.default.createElement(
          _baseButtons.TextButton,
          { handleClick: this.props.handleDelete },
          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
        ),
        _react2.default.createElement(_privacyToggle2.default, {
          bibId: this.props.bibId,
          handlePrivacyToggle: this.props.handlePrivacyToggle,
          isPrivate: this.props.isPrivate,
          showLabel: true })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-video-preview' },
        _react2.default.createElement(
          'div',
          { className: 'embed-responsive embed-responsive-16by9' },
          _react2.default.createElement('iframe', { className: 'embed-responsive-item', src: this.props.iFrameSrc })
        ),
        this.props.videoTitle ? this.renderTitle() : null,
        this.renderDescription(),
        this.props.showActions ? this.renderActions() : null
      );
    }
  }]);

  return VideoPreview;
}(_baseBcReactComponent2.default);

VideoPreview.propTypes = {
  bibId: _react.PropTypes.number.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handleDelete: _react.PropTypes.func,
  handleShowForm: _react.PropTypes.func,
  iFrameSrc: _react.PropTypes.string.isRequired,
  videoTitle: _react.PropTypes.string,
  description: _react.PropTypes.string,
  showActions: _react.PropTypes.bool
};

VideoPreview.defaultProps = {
  showActions: true
};

exports.default = VideoPreview;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/video-preview/components/VideoPreview.js
// module id = 1541
// module chunks = 1